import { createFileRoute } from "@tanstack/react-router";
import { RepresentativeOrdersPage } from "@/components/representative/RepresentativeOrdersPage";
import { DICTS } from "@/lib/i18n";

export const Route = createFileRoute("/representative/orders")({
  ssr: false,
  component: RepresentativeOrdersPage,
  head: () => ({
    meta: [
      { title: `${DICTS.en["representative.title"]} · Lecmo Perfume` },
      { name: "description", content: DICTS.en["representative.meta.description"] },
      { property: "og:title", content: `${DICTS.en["representative.title"]} · Lecmo Perfume` },
      { property: "og:description", content: DICTS.en["representative.meta.description"] },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
});
